import ClientNavbar from "../navbar/ClientNavbar";
import ClientFooter from "../footer/ClientFooter";
import { Outlet } from "react-router-dom";


const ClientLayout = () => {
    return (
        <main className='clientMain'>
            <ClientNavbar />
            <div className="clientContainer">
                <Outlet />
            </div>
            <ClientFooter />
        </main>
    )
}

export default ClientLayout